import styled from "styled-components";
import { duration, easing, spacing, typographyMixin, zIndex } from "@magicbi/ui-library";

/** Docked right panel: slides in with the motion tokens; reduced motion shows it without the slide. */
export const Panel = styled.aside<{ $open: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: ${zIndex.modal};
  display: flex;
  flex-direction: column;
  width: min(24rem, 100vw);
  color: ${({ theme }) => theme.colors.text.primary};
  background: ${({ theme }) => theme.colors.surface.primary};
  border-left: 1px solid ${({ theme }) => theme.colors.border.stroke};
  transform: translateX(${({ $open }) => ($open ? "0" : "100%")});
  visibility: ${({ $open }) => ($open ? "visible" : "hidden")};
  transition: transform ${duration.normal} ${easing.slideIn}, visibility 0s linear ${({ $open }) => ($open ? "0s" : duration.normal)};

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const Body = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${spacing[3]};
  min-height: 0;
  padding: ${spacing[3]};
  overflow-y: auto;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  ${typographyMixin("caption", 3)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Result = styled.p`
  margin: 0;
  ${typographyMixin("body", 3)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Footer = styled.div`
  padding: ${spacing[3]};
  border-top: 1px solid ${({ theme }) => theme.colors.border.stroke};
`;
